<div khA11yGroup (click)="clickPopover()" [class.cursor]="hasAction">
  <div *ngIf="khPopoverHeader" khA11yLabelSource class="kh-popover-header d-flex justify-content-between align-items-center" [style.background-color]="headerBg">
    <ng-container [ngTemplateOutlet]="khPopoverHeader"></ng-container>
    <ng-container *ngIf="canClose" [style.color]="iconColor">
      <ng-container *ngTemplateOutlet="icon"></ng-container>
    </ng-container>
  </div>
  <div class="kh-popover-body d-flex justify-content-between" [style.background-color]="bodyBg" [class.kh-only-body-mode]="!khPopoverHeader">
    <ng-content></ng-content>
    <ng-container *ngIf="canClose && !khPopoverHeader">
      <ng-container *ngTemplateOutlet="icon"></ng-container>
    </ng-container>
  </div>
</div>
<ng-template #icon>
  <button khA11yActionButton class="kh-modal-close-button kh-popover-close cursor fa-lg" [class.white-close-icon]="whiteIcon" [style.color]="iconColor" (click)="closePopover()" [khA11yLabel]="'A11Y_LABEL.CLOSE' | translate"><fa-icon khA11yHidden [icon]="['fas','times']"></fa-icon></button>
</ng-template>
